import AppLink from "@components/link/link";

import { useProgramsSection } from "../programs-section-context";

/**
 * Where a blocked manager review is unblocked, and a review package is approved: this
 * review's Results tab.
 *
 * A link and never a button, even for a reader who may calibrate the person. The Results
 * tab shows the pre-calibration ratings beside "Mark as Calibrated", so nobody releases a
 * manager review from here without seeing whether any rating was set. Used by the
 * Progress tab popover and by a waiting review on the Reviews home page.
 */
const GoToResultsLink = ({
  complianceProgramId,
}: {
  complianceProgramId: number;
}) => {
  const { basePath } = useProgramsSection();
  // "manager" is the Results tab of a review with a manager review, which is the only
  // kind of review that has pre-calibration to wait for. Its rows also carry "Approve".
  return (
    <AppLink
      to={`${basePath}/${complianceProgramId}/reporting/manager`}
      className="text-sm text-blue-600 hover:underline"
    >
      Go to Results
    </AppLink>
  );
};

export default GoToResultsLink;
